module.exports = __webpack_public_path__ + "static/result_sejong-ee501daaa6bde92c25660f30b7161fde.png";